import { Box, BoxProps } from '@mui/material'
import { EmtAvatar, EmtIcon, EmtTypography } from 'emt-components-v2'
import React from 'react'
import { useEMTState } from '@/store'
import { UserCardAnimal } from '@/dataV3/Search/UserCard'

interface Props extends BoxProps {
  pet: Omit<UserCardAnimal, '@profile'>
}

const InlinePet: React.FC<Props> = ({ pet, ...props }) => {
  const { dogBreeds, catBreeds, nacBreeds } = useEMTState().configuration

  return (
    <Box
      {...props}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: '16px',
        padding: '20px',
        backgroundColor: '#fff',
        borderRadius: '16px',
        border: '1px solid #E8E8EA',
        width: '100%',
        ...props?.sx,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '5px',
          width: '100%',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Box
            sx={{
              position: 'relative',
              width: '40px',
              height: '40px',
              overflow: 'hidden',
              display: 'flex',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <EmtAvatar
              sx={{
                flexShrink: 0,
                height: '100%!important',
                width: '100%',
              }}
              size="small"
              variant="rounded"
              src={pet.mainPictureThumbnailUrl ?? ''}
              icon={`emt-${pet.speciesSlug}`}
            />
          </Box>
          <Box>
            <EmtTypography variant="body1" fontWeight="700">
              {pet.displayName}
            </EmtTypography>
            <Box sx={{ display: 'flex', alignItems: 'center', maxWidth: '200px' }}>
              <EmtTypography
                variant="body2"
                sx={{
                  display: 'flex',
                  gap: '4px!important',
                  alignItems: 'center',
                  width: '100%',
                  color: '#A5A3A9!important',
                }}
              >
                <EmtIcon className={`emt-${pet.speciesSlug}`} size="small" sx={{ flexShrink: 0, color: '#A5A3A9' }} />
                <span
                  style={{
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    display: 'block',
                    width: '100%',
                  }}
                >
                  {dogBreeds.find((breed) => breed.id === pet.breedSlug)?.name ||
                    catBreeds.find((breed) => breed.id === pet.breedSlug)?.name ||
                    nacBreeds.find((breed) => breed.id === pet.breedSlug)?.name}
                </span>
              </EmtTypography>
            </Box>
          </Box>
        </Box>
        <EmtIcon className="emt-right-1" size="small" />
      </Box>
    </Box>
  )
}

export default InlinePet
